import CollapsibleController from '../../frontend/shared/collapsible_controller'

export default class extends CollapsibleController {
}
